<template>
  <Transition name="slide-up">
    <div v-if="!isAccepted" class="cookie-banner" role="alert">
      <div class="cookie-banner__content">
        <p class="cookie-banner__text">
          We use cookies to enhance your experience and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
        </p>
        <div class="cookie-banner__actions">
          <button @click="acceptAll" class="cookie-banner__button cookie-banner__button--primary">
            Accept All
          </button>
          <button @click="rejectAll" class="cookie-banner__button cookie-banner__button--secondary">
            Reject All
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

const isAccepted = ref(false);

const COOKIE_CONSENT_KEY = 'cookie-consent-status';

onMounted(() => {
  const savedStatus = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (savedStatus === 'accepted' || savedStatus === 'rejected') {
    isAccepted.value = true;
  }
});

const acceptAll = () => {
  localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
  isAccepted.value = true;
};

const rejectAll = () => {
  localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
  isAccepted.value = true;
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--bg-color, #12121ance);
  border-top: 1px solid var(--border-color, #333);
  padding: 1.5rem;
  z-index: 9999;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.5);
}

.cookie-banner__content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

@media (min-width: 768px) {
  .cookie-banner__content {
    flex-direction: row;
    justify-content: space-between;
  }
}

.cookie-banner__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-color, #fff);
  max-width: 600px;
}

.cookie-banner__actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.cookie-banner__button {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;
}

.cookie-banner__button:hover {
  opacity: 0.8;
}

.cookie-banner__button--primary {
  background-color: #1db954;
  color: #fff;
}

.cookie-banner__button--secondary {
  background-color: #333;
  color: #fff;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>

